<template>
  <div>
    <div
      class="
        bg-radient-light-repeat
        pdf-margin-left pdf-margin-right pdf-padding-top
        how-to-border
      "
    >
      <h2 class="hr pdf-margin-bottom">HOW TO BUY</h2>
      <p class="text-m pdf-margin-bottom">
        <span class="bold">IN THIS GUIDE,</span> we will show you how to
        <span class="break">
          become a holder of the
          <span class="bold">ATH GAMES TOKEN.</span></span
        >
        <span class="bold break">TOKEN ADDRESS</span>
        <button
          id="copyButton1"
          class="copy-button"
          @click.prevent="copyTokenAddress()"
        >
          <span class="bold address"
            >0x632a21a913a4b59b561b999cf473109e37e87b39</span
          >
          <span>&nbsp;</span>
          <i class="far fa-copy"></i>
        </button>
      </p>
      <b-popover
        custom-class="copy-pop-over"
        target="copyButton1"
        triggers="focus"
      >
        <span class="bold">COPIED!</span>
      </b-popover>

      <!-- SECTION 1 !-->
      <h3>1. DOWNLOAD A WALLET APP</h3>
      <p class="text-s">
        We recommend the <span class="bold">Trust Wallet</span> app,
        <span class="break">which you can download here:</span>
      </p>
      <button
        class="pdf-margin-bottom"
        style="
          background-color: transparent;
          width: 11vw;
          border: none;
          max-width: 400px;
          min-width: 100px;
        "
        @click="
          goToWindow(
            'https://play.google.com/store/apps/details?id=com.wallet.crypto.trustapp'
          )
        "
      >
        <img
          class="google-play"
          src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          alt=""
        />
      </button>

      <!-- SECTION 2 !-->
      <h3 class="element-margin">2. CREATE YOUR MULTICOIN WALLET</h3>
      <ImageAndNumber number="2.1" img="2.1.png" />
      <p class="text-s element-margin">
        Follow the instructions within the app.
      </p>
      <ImageAndNumber number="2.2" img="2.3.png" />
      <p class="text-s element-margin">
        Every wallet will have a 12-word <span class="bold">seed phrase</span>
        <span class="break"> as backup. Store this combination physically</span>
        and <span class="bold underline">NEVER</span> share it with anyone.
      </p>
      <ImageAndNumber number="2.3" img="2.4.png" />
      <p class="text-s pdf-margin-bottom">
        After confirming the 12-word seed phrase,
        <span class="break">the wallet will be created.</span>
      </p>

      <!-- SECTION 3 !-->
      <h3 class="element-margin">3. SETUP A PASSCODE</h3>
      <ImageAndNumber number="3.1" img="3.1.png" />
      <p class="text-s element-margin">
        Go to the <span class="bold">Settings</span> menu
        <span class="break"
          >and tap on <span class="bold">Security.</span></span
        >
      </p>
      <ImageAndNumber number="3.2" img="3.3.png" />
      <p class="text-s pdf-margin-bottom">
        Enable <span class="bold">Passcode.</span>
      </p>

      <!-- SECTION 4 !-->
      <h3 class="element-margin">4. ADD FUNDS TO YOUR WALLET</h3>
      <ImageAndNumber number="4.1" img="4.1.png" />
      <p class="text-s element-margin">
        From the <span class="bold">WALLET</span> screen, tap on
        <span class="bold">BUY.</span>
      </p>
      <ImageAndNumber number="4.2" img="4.2.png" />
      <p class="text-s element-margin">
        Tap on <span class="bold">Smart Chain.</span>
      </p>
      <ImageAndNumber number="4.3" img="4.4.png" />
      <p class="text-s element-margin">
        Tap on <span class="bold">Third Party Provider</span> selection.
      </p>
      <ImageAndNumber number="4.4" img="4.5.png" />
      <p class="text-s element-margin">
        Choose the service provider with the
        <span class="bold">Best rate.</span>
      </p>
      <ImageAndNumber number="4.5" img="4.6.png" />
      <p class="text-s pdf-margin-bottom">
        Tap <span class="bold">NEXT.</span>
        <span class="break">Complete the transaction</span> on the service
        provider page.
      </p>

      <!-- SECTION 5 !-->
      <h3 class="element-margin">5. CONNECT WALLET TO PANCAKESWAP</h3>
      <ImageAndNumber number="5.1" img="7.1.2__5.1.png" />
      <p class="text-s element-margin">
        In your <span class="bold">Trust Wallet</span> app, tap
        <span class="bold">DApps,</span>
        <span class="break"
          >then find and tap <span class="bold">PancakeSwap.</span></span
        >
      </p>
      <ImageAndNumber number="5.2" img="5.3.png" />
      <p class="text-s element-margin">
        When accessing PancakeSwap for the first time,
        <span class="break"
          >there might be an immediate <span class="bold">Connect</span> prompt
          that allows</span
        >
        you to skip Step <span class="bold">5.2</span> and
        <span class="bold">5.3.</span> In case the Connect window
        <span class="break"
          >did not appear, tap <span class="bold">Connect Wallet</span> in the
          top right.</span
        >
      </p>
      <ImageAndNumber number="5.3" img="5.4.png" />
      <p class="text-s element-margin">
        Choose
        <span class="bold"> Trust Wallet.</span>
      </p>
      <ImageAndNumber number="5.4" img="5.5.png" />
      <p class="text-s element-margin">
        Ensure that <span class="bold">BINANCE SMART CHAIN</span> is selected.
        <span class="break">Tap the icon in the top right,</span> next to the
        three dots.
      </p>

      <ImageAndNumber number="5.5" img="5.6.png" />
      <p class="text-s pdf-margin-bottom">
        Select <span class="bold">Smart Chain</span> from the list.
      </p>

      <!-- SECTION 6 !-->
      <h3 class="element-margin">6. SET THE SLIPPAGE</h3>
      <ImageAndNumber number="6.1" img="6.1.png" />
      <p class="text-s element-margin">
        Click the <span class="bold">SETTINGS (cogwheel)</span>
        <span class="break">icon in the top right inside</span> the
        <span class="bold">PancakeSwap</span>
        window.
      </p>
      <ImageAndNumber id="6.2" number="6.2" img="6.2.png" />
      <p class="text-s pdf-margin-bottom">
        Set <span class="bold">Slippage Tolerance</span> to a minimum of
        <span class="bold">7%</span>
        <span class="break"
          >for the transaction to go through. (Our Token has</span
        >
        a <span class="bold">6%</span> transaction fee, so it has to be above
        this value) <span class="break"></span> If that does not work, try to
        increase it by <span class="bold">1%</span> incrementally.
        <span class="break">
          <span class="bold">SLIPPAGE:</span> The tolerance for a change in
          price.</span
        >
      </p>

      <!-- SECTION 7 !-->
      <h3 class="element-margin">7. ADD ATHD TOKEN IN PANCAKESWAP</h3>
      <ImageAndNumber number="7.1" img="7.1.2__5.1.png" />
      <p class="text-s element-margin">
        In your <span class="bold">Trust Wallet</span> app, go to
        <span class="bold">DApps,</span>
        <span class="break">then <span class="bold">PancakeSwap.</span></span>
      </p>
      <ImageAndNumber number="7.2" img="7.2.2.png" />
      <p class="text-s element-margin">Click on the bottom token.</p>
      <ImageAndNumber number="7.3" img="7.3.png" />
      <p class="text-s element-margin">
        Enter our <span class="bold">ATHD Token address</span> and select it.
        <span class="break"
          >The address is:
          <button
            id="copyButton2"
            class="copy-button"
            @click.prevent="copyTokenAddress()"
          >
            <span class="bold address"
              >0x632a21a913a4b59b561b999cf473109e37e87b39</span
            >
            <span>&nbsp;</span>
            <i class="far fa-copy"></i>
          </button>
        </span>
        Confirm the <span class="bold">Notification</span> pop-up that appears.
      </p>
      <b-popover
        custom-class="copy-pop-over"
        target="copyButton2"
        triggers="focus"
      >
        <span class="bold">COPIED!</span>
      </b-popover>

      <ImageAndNumber number="7.4" img="7.4.png" />
      <p class="text-s pdf-margin-bottom">
        The bottom token will have changed to <span class="bold">ATHD.</span>
      </p>
      <!-- SECTION 8 !-->
      <h3 class="element-margin">8. SWAP TO ATHD TOKEN</h3>
      <ImageAndNumber number="8.1" img="7.5.png" />
      <p class="text-s element-margin">
        Enter the amount of <span class="bold">BNB</span> you wish to buy
        <span class="bold">ATHD</span>
        with and tap <span class="bold">Swap.</span>
        <span class="break"
          >If your transaction fails, you may want to adjust your
          <span class="bold">Slippage Tolerance</span> to
          <span class="bold">8%.</span>
        </span>
        If that does not work, try to increase it by
        <span class="bold">1% </span> incrementally.

        <a
          class="underline break-on-mobile"
          href="#6.2"
          @auxclick.prevent.stop="returnFalse"
          >See <span class="bold">6.2</span> for instructions</a
        >
      </p>
      <ImageAndNumber number="8.2" img="7.6.1.png" />
      <p class="text-s element-margin">
        Confirm the amount and tap <span class="bold">Confirm Swap.</span>
      </p>
      <ImageAndNumber number="8.3" img="7.7.png" />
      <p class="text-s element-margin">
        Wait for the <span class="bold"> Smart Contract Call</span> window to
        appear.
      </p>
      <ImageAndNumber number="8.4" img="7.8.1.png" />
      <p class="text-s element-margin">
        Tap <span class="bold">APPROVE.</span>
      </p>
      <ImageAndNumber number="8.5" img="7.9.png" />
      <p class="text-s pdf-margin-bottom">
        <span class="bold">HOORAY!</span> You’re an
        <span class="bold">ATH GAMES TOKEN</span> holder now!
      </p>

      <!-- SECTION 8 !-->
      <h3>9. DISPLAY ATHD TOKEN IN TRUST WALLET</h3>
      <p class="text-s element-margin">
        This section is only necessary if the ATHD Token didn’t show up
        automatically in your wallet
      </p>
      <ImageAndNumber number="9.1" img="9.1.png" />
      <p class="text-s element-margin">
        Back in your <span class="bold">Wallet</span> screen, tap the top right
        icon.
      </p>
      <ImageAndNumber number="9.2" img="9.2.png" />
      <p class="text-s element-margin">
        <span class="break">Enter our token address</span>
        <button
          id="copyButton3"
          class="copy-button"
          @click.prevent="copyTokenAddress()"
        >
          <span class="bold address"
            >0x632a21a913a4b59b561b999cf473109e37e87b39</span
          >
          <span>&nbsp;</span>
          <i class="far fa-copy"></i>
        </button>

        <span class="break"
          >and select the <span class="bold">ATHD Token</span> from the
          list.</span
        >If the Token is not displayed, tap on
        <span class="bold">Add Custom Token.</span>
      </p>
      <b-popover
        custom-class="copy-pop-over"
        target="copyButton3"
        triggers="focus"
      >
        <span class="bold">COPIED!</span>
      </b-popover>
      <ImageAndNumber number="9.3" img="9.3.png" />
      <p class="text-s element-margin">
        Tap on the <span class="bold">Network</span> selection.
      </p>

      <ImageAndNumber number="9.4" img="9.4.png" />
      <p class="text-s element-margin">
        Select <span class="bold">Smart Chain</span> from the list.
      </p>
      <ImageAndNumber number="9.5" img="9.5.png" />
      <p class="text-s element-margin">
        <span class="bold">Paste</span> our ATHD Token address under
        <span class="bold">Contract Address.</span>
        <span class="break">The details should be autofilled for you.</span>
        If not, enter them as shown here.
      </p>
      <ImageAndNumber :ios="true" number="9.6" img="9.6.png" />
      <p class="text-s pdf-padding-bottom">
        You can now track your <span class="bold">ATHD Token</span>
      </p>

      <div
        class="pdf-padding-top pdf-padding-bottom"
        style="text-align: center"
      >
        <p class="text-m bold">DISCLAIMER</p>
        <p class="text-s">
          Ensure that any entered wallet address is correct and that you closely
          <span class="break"
            >follow this guide step by step. Buying
            <span class="bold">BNB</span> directly through
            <span class="bold">TRUST WALLET</span>
          </span>
          might not work in your region. If this is the case, please use another
          platform
          <span class="break"
            >to purchase <span class="bold">BNB</span> and send them to your
            Trust Wallet’s <span class="bold">BSC address,</span>
          </span>
          for example <span class="bold">WWW.BINANCE.COM</span> or
          <span class="bold">COINSWAP.SPACE</span>
        </p>
        <p class="text-s">
          You are welcome to use our social media channels to ask for any help
          on this matter!
        </p>
      </div>
      <div class="pdf-padding-top">
        <SocialIcons />
      </div>
    </div>
  </div>
</template>

<script>
import SocialIcons from "../components/SocialIcons.vue";
import ImageAndNumber from "../components/ImageAndNumber.vue";

export default {
  methods: {
    goToWindow(url) {
      window.open(url);
    },
    returnFalse(e) {
      e.preventDefault();
      return false;
    },
    copyToClipBoard(text) {
      navigator.clipboard.writeText(text);
    },
    copyTokenAddress() {
      navigator.clipboard.writeText(
        "0x632a21a913a4b59b561b999cf473109e37e87b39"
      );
    },
  },
  components: { SocialIcons, ImageAndNumber },
};
</script>

<style scoped>
.google-play {
  box-shadow: rgba(0, 0, 0, 1) 0px 0px 15px, rgba(0, 0, 0, 1) 0px 0px 15px;
}
.how-to-border {
  border-right: 4px solid #1c1a24;
  border-left: 4px solid #1c1a24;
}
.element-margin {
  margin-bottom: 3vw;
}
.sub-title-text {
  width: 65vw;
}

.screenshot-img {
  width: 12vw;
  max-width: 280px !important;
}

.red-button {
  border-radius: 0.5vw;
}
.space-right {
  margin-right: 2vw;
}

.social-icon-container i {
  padding-bottom: 0.7vw;
}

.copy-button {
  color: white;
  background-color: transparent;
  border: none;
}

.social-icons {
  font-size: 1rem;
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(5, 10%);
  grid-column-gap: 0.5em;
}

@media (max-width: 992px) {
  .social-icons {
    grid-column-gap: 2em;
  }
  .sub-title-text {
    width: 90%;
  }
  .pdf-margin-left {
    margin-left: 0 !important;
  }
  .pdf-margin-right {
    margin-right: 0 !important;
  }
  .how-to-border {
    border: none !important;
  }
  .break-on-mobile {
    display: block;
  }
  .element-margin {
    margin-bottom: 5vw;
  }
}
</style>
